import { parseNullableValue } from '@clearverify/utils';

import { type PermissiblePurposeReferenceForVerifiersDashboardItem } from 'src/types/permissiblePurposeReference';
import { insertLinebreaks } from 'src/utils/string';

export const prepareDataset = (
  permissiblePurposeReferenceData: PermissiblePurposeReferenceForVerifiersDashboardItem[],
) => {
  return permissiblePurposeReferenceData.map(item => ({
    purposeValue: insertLinebreaks(parseNullableValue(item.label), 45, 3),
    count: item.permissiblePurposesCount,
  }));
};
